import React, { useState } from "react";
import styles from "./counter.module.scss";
import { Button } from "@mui/material";

export function Counter({
  screens,
  min = 1,
  max = 20,
  increment = 1,
  decrement = 1,
  onCountChange,
}) {
  const [count, setCount] = useState(screens);
  function handleClickAdd() {
    if (count < max) {
      setCount(count + increment);
      onCountChange(count + increment);
    }
  }
  function handleClickSubtract() {
    if (count > min) {
      setCount(count - decrement);
      onCountChange(count - decrement);
    }
  }
  function handleClick(e) {
    setCount(e.target.valueAsNumber);
    onCountChange(e.target.valueAsNumber);
  }



  return (
    <div className={styles.counter}>
      <Button onClick={handleClickSubtract} className={styles.actionbutton}>
        -
      </Button>
      <input
        className={styles.counterInput}
        type="number"
        min={min}
        max={max}
        value={count}
        width="80px"
        onChange={handleClick}
      />
      <Button onClick={handleClickAdd} className={styles.actionbutton}>
        +
      </Button>
    </div>
  );
}
